(() => {
  if (customElements.get('views-kiosques-007')) return;

  const GEOCODEUR = 'https://data.geopf.fr/geocodage/search';
  const TUILES = 'https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}';
  const FRANCE = [[42.3, -4.8], [51.1, 8.2]];
  const PAR_PAGE = 3;
  const MAXIMUM = 12;
  const LOIN_KM = 50;
  const HORS_ZONE_KM = 300;

  const el = (tag, classe, texte) => {
    const n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texte != null) n.textContent = texte;
    return n;
  };

  const rad = (v) => (v * Math.PI) / 180;
  const distanceKm = (a, b) => {
    const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lon - a.lon) / 2) ** 2;
    return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
  };
  const decimal = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
  const formaterDistance = (km) => {
    if (km < 1) return `${Math.max(10, Math.round(km * 100) * 10)} m`;
    if (km < 10) return `${decimal.format(Math.round(km * 10) / 10)} km`;
    return `${Math.round(km)} km`;
  };
  const libelleDistance = (p, km) => {
    if (p.precision === 'commune') return km < PENALITE_COMMUNE_KM ? 'Dans la commune' : `≈ ${Math.round(km)} km`;
    return `${p.precision === 'adresse' ? '' : '≈ '}${formaterDistance(km)}`;
  };
  const villeAffichee = (p) => p.ville.replace(/^(PARIS|LYON|MARSEILLE) \d{2}$/, '$1');
  const adresseComplete = (p) => `${p.adresse}, ${p.cp} ${villeAffichee(p)}`;
  const lienItineraire = (p) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(adresseComplete(p))}`;

  const chargements = new Map();
  const charger = (url, feuille) => {
    if (!chargements.has(url)) {
      const promesse = new Promise((resolve, reject) => {
        const tag = document.createElement(feuille ? 'link' : 'script');
        const minuteur = setTimeout(() => reject(new Error('delai')), 15000);
        tag.onload = () => { clearTimeout(minuteur); resolve(); };
        tag.onerror = () => { clearTimeout(minuteur); tag.remove(); reject(new Error('echec')); };
        if (feuille) { tag.rel = 'stylesheet'; tag.href = url; } else { tag.src = url; tag.async = true; }
        document.head.append(tag);
      });
      promesse.catch(() => chargements.delete(url));
      chargements.set(url, promesse);
    }
    return chargements.get(url);
  };

  const guillemets = (texte) => `« ${texte} »`;
  const departement = (cp) => (String(cp || '').startsWith('98') ? '06' : String(cp || '').slice(0, 2));

  let listeEnCours = null;
  const chargerListe = (url) => {
    if (!listeEnCours) {
      listeEnCours = fetch(url, { credentials: 'omit' })
        .then((r) => { if (!r.ok) throw new Error('liste'); return r.json(); })
        .then((d) => {
          if (d.numero !== '007' || !Array.isArray(d.points) || d.points.length !== d.total) throw new Error('liste');
          const valides = d.points.filter((p) => typeof p.nom === 'string' && typeof p.adresse === 'string' && typeof p.cp === 'string' && typeof p.ville === 'string');
          return {
            situes: valides.filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lon)),
            sansPosition: valides.filter((p) => !Number.isFinite(p.lat) || !Number.isFinite(p.lon)),
          };
        });
      listeEnCours.catch(() => { listeEnCours = null; });
    }
    return listeEnCours;
  };

  const geocoder = async (q, autocompletion, signal, type) => {
    const url = new URL(GEOCODEUR);
    const parametres = { q, limit: '5', autocomplete: autocompletion ? '1' : '0' };
    if (type) parametres.type = type;
    url.search = new URLSearchParams(parametres).toString();
    const r = await fetch(url, { signal, credentials: 'omit' });
    if (!r.ok) throw new Error('geocodeur');
    const d = await r.json();
    return (Array.isArray(d.features) ? d.features : [])
      .map((f) => {
        const c = f && f.geometry && f.geometry.type === 'Point' ? f.geometry.coordinates : null;
        const p = (f && f.properties) || {};
        return {
          lat: c ? Number(c[1]) : NaN,
          lon: c ? Number(c[0]) : NaN,
          label: String(p.label || ''),
          nom: String(p.name || p.label || ''),
          lieu: [p.postcode, p.city].filter(Boolean).join(' '),
          cp: String(p.postcode || ''),
          type: String(p.type || ''),
          score: Number(p.score) || 0,
          population: Number(p.population) || 0,
        };
      })
      .filter((c) => Number.isFinite(c.lat) && Number.isFinite(c.lon) && c.label);
  };

  const MOTS_DE_VOIE = /\b(rue|r|avenue|av|ave|boulevard|bd|place|pl|chemin|che|allee|allée|quai|route|rte|impasse|imp|cours|crs|square|passage|faubourg|fbg|voie|sentier|lotissement|zac|za|zi)\b/i;
  const PENALITE_COMMUNE_KM = 3;
  const cleDeTri = (p) => p.km + (p.precision === 'commune' ? PENALITE_COMMUNE_KM : 0);

  const avecDelai = (ms) => {
    const controleur = new AbortController();
    const minuteur = setTimeout(() => controleur.abort(), ms);
    return { controleur, fin: () => clearTimeout(minuteur) };
  };

  class ViewsKiosques007 extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.pret = true;
      this.form = this.querySelector('form');
      this.champ = this.querySelector('.vk__input');
      this.bouton = this.querySelector('.vk__submit');
      this.liste = this.querySelector('.vk__suggestions');
      this.statut = this.querySelector('[data-status]');
      this.alternatives = this.querySelector('[data-alternatives]');
      this.resultats = this.querySelector('[data-results]');
      this.plus = this.querySelector('[data-more]');
      this.cadre = this.querySelector('[data-map-wrap]');
      this.zone = this.querySelector('[data-map]');
      this.voile = this.querySelector('[data-veil]');
      this.terminer = this.querySelector('[data-relock]');
      this.version = 0;
      this.suggestions = [];
      this.actif = -1;
      this.affiches = 0;
      this.classes = [];
      this.libre = false;
      this.tactile = window.matchMedia('(pointer: coarse)').matches;

      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.valider(); });
      this.champ.addEventListener('input', () => this.saisie());
      this.champ.addEventListener('keydown', (e) => this.clavier(e));
      this.champ.addEventListener('blur', () => setTimeout(() => this.fermer(), 150));
      this.liste.addEventListener('mousedown', (e) => e.preventDefault());
      this.liste.addEventListener('click', (e) => {
        const option = e.target.closest('[data-i]');
        if (option) this.choisir(this.suggestions[Number(option.dataset.i)]);
      });
      this.querySelector('[data-locate]').addEventListener('click', () => this.localiser());
      this.plus.addEventListener('click', () => this.afficher(this.affiches + PAR_PAGE));
      this.voile.addEventListener('click', () => this.deverrouiller());
      this.terminer.addEventListener('click', () => { this.verrouiller(); this.voile.focus({ preventScroll: true }); });
      this.cadre.addEventListener('mouseleave', () => { if (!this.tactile) this.verrouiller(); });

      if ('IntersectionObserver' in window) {
        this.observateur = new IntersectionObserver((entrees) => {
          for (const e of entrees) {
            if (e.isIntersecting) this.carte();
            else if (this.tactile) this.verrouiller();
          }
        }, { rootMargin: '300px 0px' });
        this.observateur.observe(this.cadre);
      } else {
        this.carte();
      }
    }

    disconnectedCallback() {
      if (this.observateur) this.observateur.disconnect();
      if (this.redimension) this.redimension.disconnect();
    }

    texte() {
      return this.champ.value.replace(/\s+/g, ' ').trim().slice(0, 120);
    }

    dire(message) {
      this.statut.textContent = message;
    }

    occupe(oui) {
      this.form.setAttribute('aria-busy', String(oui));
      this.bouton.disabled = oui;
    }

    saisie() {
      clearTimeout(this.minuteurSaisie);
      if (this.suggestionEnCours) this.suggestionEnCours.abort();
      this.suggestionEnCours = null;
      this.suggestions = [];
      this.liste.replaceChildren();
      this.fermer();
      const q = this.texte();
      if (q.length < 3 || !/^[\p{L}\p{N}]/u.test(q)) return;
      this.minuteurSaisie = setTimeout(async () => {
        const { controleur, fin } = avecDelai(6000);
        this.suggestionEnCours = controleur;
        try {
          const s = await geocoder(q, true, controleur.signal);
          if (controleur === this.suggestionEnCours && this.texte() === q && document.activeElement === this.champ) this.proposer(s);
        } catch {
          if (controleur === this.suggestionEnCours) this.fermer();
        } finally {
          fin();
        }
      }, 250);
    }

    proposer(suggestions) {
      this.suggestions = suggestions;
      this.actif = -1;
      this.liste.replaceChildren(...suggestions.map((c, i) => {
        const option = el('li', 'vk__suggestion');
        option.id = `${this.liste.id}-${i}`;
        option.dataset.i = String(i);
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.append(el('span', 'vk__suggestion-nom', c.nom), el('span', 'vk__suggestion-lieu', c.lieu));
        return option;
      }));
      const ouvert = suggestions.length > 0;
      this.liste.hidden = !ouvert;
      this.champ.setAttribute('aria-expanded', String(ouvert));
      this.champ.removeAttribute('aria-activedescendant');
    }

    fermer() {
      this.liste.hidden = true;
      this.actif = -1;
      this.champ.setAttribute('aria-expanded', 'false');
      this.champ.removeAttribute('aria-activedescendant');
    }

    clavier(e) {
      if (this.liste.hidden || this.suggestions.length === 0) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const n = this.suggestions.length;
        this.actif = e.key === 'ArrowDown' ? (this.actif + 1) % n : (this.actif - 1 + n) % n;
        [...this.liste.children].forEach((option, i) => option.setAttribute('aria-selected', String(i === this.actif)));
        this.champ.setAttribute('aria-activedescendant', `${this.liste.id}-${this.actif}`);
      } else if (e.key === 'Enter' && this.actif >= 0) {
        e.preventDefault();
        this.choisir(this.suggestions[this.actif]);
      } else if (e.key === 'Escape') {
        this.fermer();
      }
    }

    annulerSuggestions() {
      clearTimeout(this.minuteurSaisie);
      if (this.suggestionEnCours) this.suggestionEnCours.abort();
      this.suggestionEnCours = null;
      this.fermer();
    }

    choisir(candidat) {
      if (!candidat) return;
      this.annulerSuggestions();
      this.champ.value = candidat.label;
      this.chercherDepuis({ ...candidat, titre: `de ${guillemets(candidat.label)}` }, []);
    }

    async valider() {
      this.annulerSuggestions();
      const q = this.texte();
      if (q.length < 3 || !/^[\p{L}\p{N}]/u.test(q)) {
        this.dire('Tape au moins trois caractères : une rue, un code postal ou une ville.');
        this.champ.focus();
        return;
      }
      const version = ++this.version;
      this.dire('Recherche en cours…');
      this.occupe(true);
      const { controleur, fin } = avecDelai(8000);
      try {
        const nomDeVille = (!/\d/.test(q) && !MOTS_DE_VOIE.test(q)) || /^\d{5}$/.test(q);
        const metropole = (c) => (c.cp.startsWith('97') || c.cp.startsWith('98') ? 0 : 1);
        const communes = nomDeVille
          ? (await geocoder(q, true, controleur.signal, 'municipality'))
            .filter((c) => c.score >= 0.7)
            .sort((a, b) => (Math.abs(b.score - a.score) > 0.05 ? b.score - a.score : metropole(b) - metropole(a) || b.population - a.population))
          : [];
        const locauxAvant = nomDeVille && communes.length === 0 ? await this.rechercheLocale(q) : [];
        const candidats = communes.length || locauxAvant.length ? communes : await geocoder(q, false, controleur.signal);
        if (version !== this.version) return;
        if (candidats.length === 0) {
          const locaux = locauxAvant.length ? locauxAvant : await this.rechercheLocale(q);
          if (version !== this.version) return;
          this.vider();
          if (locaux.length) {
            this.resultats.replaceChildren(...locaux.slice(0, MAXIMUM).map((p) => this.ligne(p, null, true)));
            this.resultats.hidden = false;
            this.dire(`Points de vente pour ${guillemets(q)} :`);
          } else {
            this.dire('Adresse introuvable. Essaie avec ton code postal ou le nom de ta ville.');
          }
          return;
        }
        const [premier, ...autres] = candidats;
        const choix = communes.length
          ? autres.filter((c) => c.score >= premier.score - 0.1)
          : (premier.score < 0.6 ? autres : []);
        await this.chercherDepuis({ ...premier, titre: `de ${guillemets(premier.label)}` }, choix, version);
      } catch {
        if (version === this.version) {
          this.vider();
          this.dire('La recherche d’adresse ne répond pas. Réessaie dans un instant, ou utilise ta position.');
        }
      } finally {
        fin();
        if (version === this.version) this.occupe(false);
      }
    }

    localiser() {
      this.annulerSuggestions();
      if (!('geolocation' in navigator)) {
        this.dire('Ton navigateur ne donne pas ta position : tape plutôt ton adresse.');
        return;
      }
      const version = ++this.version;
      this.dire('Autorise la localisation dans ton navigateur…');
      this.occupe(true);
      navigator.geolocation.getCurrentPosition((position) => {
        if (version !== this.version) return;
        this.occupe(false);
        const { latitude, longitude } = position.coords;
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          this.dire('Position indisponible : tape plutôt ton adresse.');
          return;
        }
        this.champ.value = '';
        this.chercherDepuis({ lat: latitude, lon: longitude, label: 'Ta position', titre: 'de toi' }, [], version);
      }, () => {
        if (version !== this.version) return;
        this.occupe(false);
        this.dire('Localisation refusée ou indisponible : tape plutôt ton adresse.');
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 });
    }

    async chercherDepuis(origine, autres, version = ++this.version) {
      this.occupe(true);
      try {
        let liste;
        try {
          liste = await chargerListe(this.dataset.points);
        } catch {
          if (version === this.version) {
            this.vider();
            this.dire('La liste des points de vente n’a pas pu se charger. Recharge la page.');
          }
          return;
        }
        if (version !== this.version) return;
        this.origine = origine;
        this.classes = liste.situes.map((p) => ({ ...p, km: distanceKm(origine, p) })).sort((a, b) => cleDeTri(a) - cleDeTri(b) || a.id.localeCompare(b.id));
        const plusProche = this.classes.find((p) => p.precision !== 'commune');
        const depOrigine = origine.cp ? departement(origine.cp) : (plusProche && plusProche.km < 30 ? departement(plusProche.cp) : null);
        this.voisinsSansPosition = depOrigine ? liste.sansPosition.filter((p) => departement(p.cp) === depOrigine) : [];
        this.montrerAlternatives(autres, origine);
        const premier = this.classes[0];
        if ((!premier || premier.km > HORS_ZONE_KM) && this.voisinsSansPosition.length === 0) {
          this.vider(true);
          this.dire(`Aucun point de vente du n°007 près ${origine.titre} : le numéro est distribué en France métropolitaine.`);
          this.carteSur(origine, []);
          return;
        }
        this.afficher(PAR_PAGE);
        const loin = premier && premier.km > LOIN_KM ? ` Aucun à moins de ${LOIN_KM} km : le plus proche est à ${formaterDistance(premier.km)}.` : '';
        this.dire(`Les points de vente les plus proches ${origine.titre}.${loin}`);
      } finally {
        if (version === this.version) this.occupe(false);
      }
    }

    async rechercheLocale(q) {
      let liste;
      try {
        liste = await chargerListe(this.dataset.points);
      } catch {
        return [];
      }
      const normaliser = (t) => String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').replace(/\bSAINT\b/g, 'ST').replace(/\bSAINTE\b/g, 'STE').trim();
      const cible = normaliser(q);
      const cp = cible.match(/\b\d{5}\b/);
      return [...liste.situes, ...liste.sansPosition]
        .filter((p) => (cp ? p.cp === cp[0] : cible.length >= 3 && normaliser(villeAffichee(p)) === cible))
        .sort((a, b) => a.adresse.localeCompare(b.adresse, 'fr'));
    }

    montrerAlternatives(autres, origine) {
      const cle = (c) => `${c.label}|${c.cp || ''}`;
      const vus = new Set([cle(origine)]);
      const choix = autres.filter((c) => !vus.has(cle(c)) && vus.add(cle(c))).slice(0, 3);
      if (choix.length === 0) {
        this.alternatives.hidden = true;
        this.alternatives.replaceChildren();
        return;
      }
      this.alternatives.replaceChildren(el('span', 'vk__alt-titre', 'Pas le bon endroit ?'), ...choix.map((c) => {
        const b = el('button', 'vk__alt', c.cp && !c.label.includes(c.cp) ? `${c.label} (${c.cp})` : c.label);
        b.type = 'button';
        b.addEventListener('click', () => {
          this.annulerSuggestions();
          this.champ.value = c.label;
          this.chercherDepuis({ ...c, titre: `de ${guillemets(c.label)}` }, []);
        });
        return b;
      }));
      this.alternatives.hidden = false;
    }

    vider(garderAlternatives) {
      this.classes = [];
      this.voisinsSansPosition = [];
      this.affiches = 0;
      this.resultats.replaceChildren();
      this.resultats.hidden = true;
      this.plus.hidden = true;
      if (!garderAlternatives) {
        this.alternatives.hidden = true;
        this.alternatives.replaceChildren();
      }
      if (this.selection) this.selection.clearLayers();
    }

    afficher(n) {
      const disponibles = Math.min(MAXIMUM, this.classes.length);
      this.affiches = Math.min(n, disponibles);
      const visibles = this.classes.slice(0, this.affiches);
      const lignes = visibles.map((p, i) => this.ligne(p, i));
      for (const p of this.voisinsSansPosition || []) lignes.push(this.ligne(p, null));
      this.resultats.replaceChildren(...lignes);
      this.resultats.hidden = false;
      this.plus.hidden = this.affiches >= disponibles;
      this.carteSur(this.origine, visibles);
    }

    ligne(p, i, sansDistance) {
      const li = el('li', 'vk__result');
      const corps = el('div', 'vk__corps');
      corps.append(el('p', 'vk__nom', p.nom), el('p', 'vk__adresse', p.adresse), el('p', 'vk__ville', `${p.cp} ${villeAffichee(p)}`));
      if (sansDistance) corps.append(el('p', 'vk__precision', 'Distance non calculée'));
      else if (i === null) corps.append(el('p', 'vk__precision', 'Pas situé sur la carte : distance inconnue'));
      else if (p.precision === 'commune') corps.append(el('p', 'vk__precision', /^(PARIS|LYON|MARSEILLE) \d{2}$/.test(p.ville) ? 'Emplacement approximatif : centre de l’arrondissement' : 'Emplacement approximatif : centre de la commune'));
      const lien = el('a', 'vk__itineraire', 'Itinéraire');
      lien.href = lienItineraire(p);
      lien.target = '_blank';
      lien.rel = 'noopener noreferrer';
      lien.setAttribute('aria-label', `Itinéraire vers ${p.nom}, ${adresseComplete(p)}, sur Google Maps, nouvel onglet`);
      const fleche = el('span', 'vk__fleche', '↗');
      fleche.setAttribute('aria-hidden', 'true');
      lien.append(fleche);
      li.append(el('span', 'vk__rang', i === null ? '—' : String(i + 1).padStart(2, '0')), corps, el('p', 'vk__distance', i === null ? '' : libelleDistance(p, p.km)), lien);
      return li;
    }

    bulle(p) {
      const d = el('div', 'vk-bulle');
      d.append(el('strong', 'vk-bulle__nom', p.nom), el('span', 'vk-bulle__adresse', adresseComplete(p)));
      if (this.origine) d.append(el('span', 'vk-bulle__km', libelleDistance(p, distanceKm(this.origine, p))));
      const lien = el('a', 'vk-bulle__lien', 'Itinéraire ↗');
      lien.href = lienItineraire(p);
      lien.target = '_blank';
      lien.rel = 'noopener noreferrer';
      d.append(lien);
      return d;
    }

    carte() {
      if (this.carteEnCours) return this.carteEnCours;
      this.carteEnCours = (async () => {
        await Promise.all([charger(this.dataset.leafletCss, true), charger(this.dataset.leafletJs, false)]);
        const points = (await chargerListe(this.dataset.points)).situes;
        const L = window.L;
        if (!L || !this.isConnected) throw new Error('carte');
        this.cadre.classList.remove('vk__map-wrap--indisponible');
        const encre = getComputedStyle(this).color || 'rgb(18,18,18)';
        const fond = getComputedStyle(this.closest('.vk') || this).backgroundColor || 'rgb(255,255,255)';
        const carte = L.map(this.zone, {
          scrollWheelZoom: false,
          dragging: false,
          touchZoom: false,
          doubleClickZoom: false,
          boxZoom: false,
          tap: false,
          zoomSnap: 0.5,
          minZoom: 5,
          maxZoom: 19,
        });
        carte.attributionControl.setPrefix(false);
        let tuilesChargees = 0;
        let tuilesEnErreur = 0;
        L.tileLayer(TUILES, {
          maxZoom: 19,
          minZoom: 5,
          attribution: 'Fond © <a href="https://www.ign.fr/" target="_blank" rel="noopener">IGN</a> · Adresses <a href="https://adresse.data.gouv.fr/" target="_blank" rel="noopener">BAN</a>',
        }).on('tileload', () => {
          tuilesChargees += 1;
          this.cadre.classList.remove('vk__map-wrap--sans-fond');
        }).on('tileerror', () => {
          tuilesEnErreur += 1;
          if (tuilesChargees === 0 && tuilesEnErreur >= 6) this.cadre.classList.add('vk__map-wrap--sans-fond');
        }).addTo(carte);
        const rendu = L.canvas({ padding: 0.5 });
        const rayon = () => (carte.getZoom() < 8 ? 2.5 : carte.getZoom() < 12 ? 4 : 5.5);
        const marqueurs = points.map((p) => L.circleMarker([p.lat, p.lon], {
          renderer: rendu,
          radius: 2.5,
          weight: 1.5,
          color: encre,
          fillColor: p.precision === 'commune' ? fond : encre,
          fillOpacity: 1,
        }).bindPopup(() => this.bulle(p)).addTo(carte));
        carte.on('zoomend', () => {
          const r = rayon();
          for (const m of marqueurs) m.setRadius(r);
        });
        this.selection = L.layerGroup().addTo(carte);
        carte.fitBounds(FRANCE);
        this.map = carte;
        if ('ResizeObserver' in window) {
          let attente = 0;
          this.redimension = new ResizeObserver(() => {
            cancelAnimationFrame(attente);
            attente = requestAnimationFrame(() => carte.invalidateSize());
          });
          this.redimension.observe(this.zone);
        }
        this.appliquerVerrou();
        if (this.origine) this.carteSur(this.origine, this.classes.slice(0, this.affiches));
        return carte;
      })();
      this.carteEnCours.catch(() => {
        this.carteEnCours = null;
        this.cadre.classList.add('vk__map-wrap--indisponible');
      });
      return this.carteEnCours;
    }

    carteSur(origine, visibles) {
      if (!this.map) { this.carte(); return; }
      const L = window.L;
      this.selection.clearLayers();
      L.marker([origine.lat, origine.lon], {
        icon: L.divIcon({ className: 'vk-moi', html: '<span></span>', iconSize: [22, 22], iconAnchor: [11, 11] }),
        keyboard: false,
        interactive: false,
        zIndexOffset: 500,
      }).addTo(this.selection);
      visibles.forEach((p, i) => {
        L.marker([p.lat, p.lon], {
          icon: L.divIcon({ className: 'vk-pin', html: `<span>${i + 1}</span>`, iconSize: [30, 30], iconAnchor: [15, 15] }),
          title: p.nom,
          riseOnHover: true,
          zIndexOffset: 1000 - i,
        }).bindPopup(() => this.bulle(p)).addTo(this.selection);
      });
      this.map.invalidateSize();
      if (visibles.length === 0) {
        this.map.setView([origine.lat, origine.lon], 11);
        return;
      }
      const bornes = L.latLngBounds([[origine.lat, origine.lon], ...visibles.slice(0, PAR_PAGE).map((p) => [p.lat, p.lon])]);
      this.map.fitBounds(bornes, { paddingTopLeft: [56, 40], paddingBottomRight: [40, 56], maxZoom: 16 });
    }

    appliquerVerrou() {
      const carte = this.map;
      if (!carte) return;
      const action = this.libre ? 'enable' : 'disable';
      carte.scrollWheelZoom[action]();
      carte.dragging[action]();
      carte.touchZoom[action]();
      carte.doubleClickZoom[action]();
      carte.keyboard[action]();
    }

    deverrouiller() {
      this.libre = true;
      this.voile.hidden = true;
      this.terminer.hidden = false;
      this.cadre.classList.add('vk__map-wrap--libre');
      this.appliquerVerrou();
      this.carte();
      this.zone.focus({ preventScroll: true });
    }

    verrouiller() {
      if (!this.libre) return;
      this.libre = false;
      this.voile.hidden = false;
      this.terminer.hidden = true;
      this.cadre.classList.remove('vk__map-wrap--libre');
      this.appliquerVerrou();
    }
  }

  customElements.define('views-kiosques-007', ViewsKiosques007);
})();
